<template>
  <div>
    <v-container>
      <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
      <v-row align="center">
        <v-col cols="12">
          <v-row align="center" justify="center">
            <div v-for="(prop,i) in analyzeInput.props" :key="i" class="ma-5">
              <analyzePropAutoForm :ref="prop.prop" :value="prop" />
            </div>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="ma-3">
        <v-spacer></v-spacer>
        <v-btn
          class="mr-3"
          v-if="items && items.length > 0"
          color="green"
          dark
          @click="$toExcel(toColumnsJson,analyzeInput.namespace.name)"
        >
          <v-icon>mdi-file-excel-box</v-icon>
        </v-btn>
        <v-btn @click="sendFilter" color="primary">Filtrar</v-btn>
      </v-row>
    </v-container>
    <div>
      <v-data-table
        dense
        v-if="ready"
        ref="table"
        :headers="analyzeInput.pivot ? pivotHeaders : headersComp"
        :items="analyzeInput.pivot ? pivotItems : items"
        class="elevation-10 ma-10"
        hide-default-footer
        :loading="loading"
        :items-per-page="9999999"
      ></v-data-table>
    </div>
  </div>
</template>

<script>
import analyzePropAutoForm from "@/components/forms/analyzeInputs/analyzePropAutoForm";
export default {
  components: { analyzePropAutoForm },
  data() {
    return {
      alert: { alerts: [], type: "error" },
      date: "",
      inputName: "",
      items: [],
      loading: false,
      headers: [],
      ready: false,
      analyzeInput: {},
      filters: []
    };
  },
  computed: {
    pivotHeaders() {
      if (!this.analyzeInput.pivot) return [];
      if (!this.items || this.items.length == 0) return this.headersComp;

      let analyzeInput = this.analyzeInput;
      let pivotField = this.analyzeInput.pivotField;
      let pivotProp = this.analyzeInput.pivotProp;

      let pivotFields = [];

      let itemsOnField = this.items.filter(
        i => i[pivotField] != null && i[pivotField].length > 0
      );

      analyzeInput.fields.forEach(f => {
        let exist = pivotFields.filter(h => h.text == f).length > 0;
        if (!exist)
          pivotFields.push({
            text: f,
            align: "left",
            sortable: true,
            value: f
          });
      });

      itemsOnField.forEach(iof => {
        let field = iof[pivotField];

        field.forEach(f => {
          let prop = f[pivotProp];
          let exist = pivotFields.filter(h => h.text == prop).length > 0;
          if (!exist && prop != null)
            pivotFields.push({
              text: prop,
              align: "left",
              sortable: true,
              value: prop
            });
        });
      });

      return pivotFields;
    },

    pivotItems() {
      if (!this.analyzeInput.pivot) return [];
      if (!this.items || this.items.length == 0) return [];

      let pivotField = this.analyzeInput.pivotField;
      let pivotProp = this.analyzeInput.pivotProp;
      let pivotValue = this.analyzeInput.pivotValue;
      let pivot = [];

      this.items.forEach(i => {
        let field = i[pivotField];

        if (field != null) {
          field.forEach(f => {
            let prop = f[pivotProp];
            let value = f[pivotValue];
            i[prop] = value;
          });
        }

        pivot.push(i);
      });

      return pivot;
    },
    toColumnsJson() {
      if (!this.items || this.items.length == 0) return [];
      let table = [];
      table;
      if (
        this.analyzeInput.fields == null ||
        this.analyzeInput.fields.length == 0
      )
        return this.items;

      let pivotFields = [];
      this.pivotHeaders.forEach(p => pivotFields.push(p.text));

      let fields = this.analyzeInput.pivot
        ? pivotFields
        : this.analyzeInput.fields;

      let items = this.analyzeInput.pivot ? this.pivotItems : this.items;

      items.forEach(i => {
        let item = {};
        fields.forEach(f => {
          item[f] = i[f];
        });

        table.push(item);
      });

      return table;
    },
    headersComp() {
      if (this.items.length == 0) return [];
      let headers = [];

      if (this.analyzeInput.fields && this.analyzeInput.fields.length > 0) {
        this.analyzeInput.fields.forEach(f => {
          headers.push({
            text: f,
            align: "left",
            sortable: true,
            value: f
          });
        });
        return headers;
      }

      let i = this.items[0];
      let props = Object.getOwnPropertyNames(i);

      props.forEach(p => {
        if (p != "__ob__") {
          headers.push({
            text: p,
            align: "left",
            sortable: true,
            value: p
          });
        }
      });

      return headers;
    }
  },
  methods: {
    getValuesFilters() {
      this.alert.alerts = [];
      this.filters = [];
      this.analyzeInput.props.forEach(p => {
        let filter = this.$refs[p.prop][0];
        let value = filter.getValue();
        if ((value.value == "" || value.value == null) && value.isRequired) {
          this.alert.alerts.push(`Filter ${value.label} is required`);
          this.filters = [];
          return;
        }
        if (value.value && value.value != "") this.filters.push(value);
      });
    },
    async sendFilter() {
      this.getValuesFilters();
      await this.getAnalyze();
    },
    async getAnalyze() {
      if (this.alert.alerts.length > 0) return;
      this.loading = true;
      let res = await this.$http.post(
        `analyzeinput?inputName=${this.analyzeInput.namespace.name}`,
        this.filters
      );
      if (res.success) {
        this.items = res.data.data;
      }
      this.loading = false;
      this.ready = true;
    }
  },
  async mounted() {
    this.analyzeInput = JSON.parse(this.$route.query.analyzeInput);
  }
};
</script>